import { Button, message, Modal, Steps } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import StepOne from './step_one';
import StepTwo from './step_two';
import { getComponentTags, getComponentApps } from '@/services/source';
import './index.less';

const { Step } = Steps;
interface IStateAdd {
  visible: boolean;
  onCancel: Function;
  initData: Function;
  type: string;
  adsorptionCategorys: any[];
  referencePointHorizontals: any[];
  referencePointVerticals: any[];
  referenceFaceVerticals: any[];
  referenceFaceHorizontals: any[];
  targetHosts: any[];
}

export type FileType = {
  storageFileId: string;
  fileName: string;
  fileSuffix: string;
  fullPath: string;
  md5: string;
  uid: string;
  name: string;
  fileSize: number;
  [key: string]: any;
};

export default React.memo((props: IStateAdd) => {
  const {
    visible,
    onCancel,
    initData,
    type,
    adsorptionCategorys,
    referencePointHorizontals,
    referencePointVerticals,
    referenceFaceVerticals,
    referenceFaceHorizontals,
    targetHosts,
  } = props;
  const [step, setStep] = useState<number>(0);
  const [files, setFiles] = useState<FileType[]>([]);
  // [
  //   {
  //     enterpriseId: '',
  //     fileName: 'rst_advanced_sample_family',
  //     fileSize: 614400,
  //     fileSuffix: 'rfa',
  //     storageFileId: '77aec809995a40f98cf4d81874c857c2',
  //     storageId: 'fc6b054ef8624da3b5f2d53c51b002ca',
  //     path: '',
  //     folderPath: '',
  //     name: 'rst_advanced_sample_family',
  //     suffix: 'rfa',
  //     uid: 'rc-upload-1693828058588-3',
  //     md5: 'cbe5d488d7ce0d10bfe9459dc5d4206b',
  //     fullPath: '',
  //   },
  // ]
  const [isSubmitting, setIsSubmitting] = useState(false);
  const subRef = useRef<any>();
  const handleOk = () => {
    setStep(1);
  };

  const handleCancel = () => {
    onCancel();
  };

  // 提交事件
  const handleSubmit = async () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    const res = await subRef?.current.handleSubmit();
    if (res?.success) {
      if (res?.data?.details?.length > 0) {
        message.success(`成功添加 ${res?.data?.details?.length} 个构件`);
      }
      initData();
      onCancel();
    }
    setIsSubmitting(false);
  };

  // 标签列表
  const [tagList, setTagList] = useState<ELEMENT.ITagItem[]>([]);

  const [apps, setApps] = useState<any[]>([]);
  const [info, setInfo] = useState<ELEMENT.ICreateInfo>({
    type: 'create',
    currentStep: 0,
    isStopUpload: false,
    noLablesCount: 0,
    visibleLabelTree: false,
    isDragFile: false,
  });

  const formatData: any = (list: any) => {
    return list.map((item: any) => {
      return {
        label: item.name,
        value: item.code, // 数据操作使用 key, 新建结点只有key没有id
        key: item.code,
        count: item.linkCnt,
        name: item.name,
        code: item.code,
      };
    });
  };

  const getApps = async () => {
    const res = await getComponentApps('app', true);
    if (res?.success) {
      setApps(formatData(res?.data?.details || []));
    }
  };

  // 获取标签树
  useEffect(() => {
    (async function getTags() {
      const res: any = await getComponentTags();
      if (res?.success) {
        setTagList(res?.data?.details || []);
      }
    })();
    getApps();
  }, []);

  return (
    <>
      <Modal
        title={type === 'gmodeler' ? '添加正向构件' : '添加构件'}
        centered
        width={1200}
        destroyOnClose={true}
        wrapClassName="com_modal"
        visible={visible}
        maskClosable={false}
        onCancel={handleCancel}
        forceRender={true}
        footer={
          step == 0
            ? [
                <Button onClick={handleCancel} key="cancel">
                  取消
                </Button>,
                <Button type="primary" disabled={files.length == 0} onClick={handleOk} key="sub1">
                  下一步
                </Button>,
              ]
            : [
                <Button onClick={handleCancel} key="cancel">
                  取消
                </Button>,
                <Button
                  type="primary"
                  disabled={!!info.noLablesCount}
                  onClick={handleSubmit}
                  key="sub2"
                >
                  提交
                </Button>,
              ]
        }
      >
        <div style={{ width: '300px' }}>
          <Steps size="small" current={step}>
            <Step title="上传构件" />
            <Step title="填写构件信息" />
          </Steps>
        </div>

        {step == 0 && <StepOne files={files} setFiles={setFiles} tagList={tagList} type={type} />}
        {step == 1 && (
          <StepTwo
            ref={subRef}
            noLablesCount={info.noLablesCount}
            fileList={files}
            setInfo={setInfo}
            tagList={tagList}
            changeFileList={setFiles}
            apps={apps}
            adsorptionCategorys={adsorptionCategorys}
            referencePointHorizontals={referencePointHorizontals}
            referencePointVerticals={referencePointVerticals}
            referenceFaceVerticals={referenceFaceVerticals}
            referenceFaceHorizontals={referenceFaceHorizontals}
            targetHosts={targetHosts}
          />
        )}
      </Modal>
    </>
  );
});
